import { parseQuery } from '../../shared/utils/uri';

export function getUTMDataFromQueryString() {
  const queryString = window.location.search;

  if (!queryString) {
    return {};
  }

  const { utm_source, utm_medium, utm_campaign, calltest } = parseQuery(queryString);

  return {
    utm_source,
    utm_medium,
    utm_campaign: parseInt(utm_campaign || '', 10) || undefined,
    calltest: parseInt(calltest || '', 10) || undefined,
  };
}
